import api from "../axios"

export const getHealthCheck = async () => {
	return await api.get("/v2/check/health", {
		headers: {
			"Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
			"Pragma": "no-cache",
			"Expires": "0",
		},
		timeout: 5000,
	})
}